import React from 'react';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import { render } from 'react-testing-library';
import { Router } from 'react-router-dom';
import createSagaMiddleware from 'redux-saga';
import { all } from 'redux-saga/effects';
import { createMemoryHistory } from 'history';
import { defaultTheme } from '../../styles';
import { ThemeProvider } from 'styled-components';

export const renderWithRedux = (ui, reducer, initialState, saga) => {
  const sagaMiddleware = saga && createSagaMiddleware();

  const store = createStore(
    reducer,
    initialState,
    sagaMiddleware && applyMiddleware(sagaMiddleware)
  );

  if (sagaMiddleware) {
    sagaMiddleware.run(function* rootSaga() {
      yield all([saga()]);
    });
  }

  return {
    ...render(<Provider store={store}>{ui}</Provider>),
    store,
  };
};

export const renderWithTheme = (ui, theme = defaultTheme) => {
  return {
    ...render(<ThemeProvider theme={theme}>{ui}</ThemeProvider>),
    theme,
  };
};

export const renderWithRouter = (
  ui,
  {
    route = '/',
    history = createMemoryHistory({ initialEntries: [route] }),
    theme = defaultTheme,
  } = {}
) => {
  return {
    ...renderWithTheme(<Router history={history}>{ui}</Router>, theme),
    // adding `history` to the returned utilities to allow us
    // to reference it in our tests (just try to avoid using
    // this to test implementation details).
    history,
    theme,
  };
};

export const withReduxAndRouter = (
  ui,
  reducer,
  initialState,
  saga,
  {
    route = '/',
    history = createMemoryHistory({ initialEntries: [route] }),
  } = {},
  theme = defaultTheme
) => {
  const sagaMiddleware = saga && createSagaMiddleware();

  const store = createStore(
    reducer,
    initialState,
    sagaMiddleware && applyMiddleware(sagaMiddleware)
  );

  if (sagaMiddleware) {
    sagaMiddleware.run(function* rootSaga() {
      yield all(saga.length ? saga : [saga()]);
    });
  }

  return {
    ...render(
      <Provider store={store}>
        <Router history={history}>
          <ThemeProvider theme={theme}>{ui}</ThemeProvider>
        </Router>
      </Provider>
    ),
    store,
    history,
    theme,
  };
};
